__turbopack_context__.v({
  "tag": "CourseTag-module__E5CQva__tag",
  "tagDot": "CourseTag-module__E5CQva__tagDot",
  "tagText": "CourseTag-module__E5CQva__tagText",
});
